import LegalDocumentPage from '../components/legal/LegalDocumentPage.jsx'

const sections = [
  {
    title: 'Objet',
    paragraphs: [
      'Les présentes conditions générales d’utilisation encadrent l’accès et l’utilisation de la plateforme USTS et de ses fonctionnalités associées.',
      'En accédant au service, l’utilisateur accepte de respecter les présentes règles d’utilisation ainsi que les lois et règlements applicables.',
    ],
  },
  {
    title: 'Accès au service',
    paragraphs: [
      'L’accès au service peut nécessiter la création d’un compte et l’authentification via Google.',
      'USTS se réserve le droit de suspendre ou de limiter l’accès à tout utilisateur en cas d’usage frauduleux, abusif ou non conforme.',
    ],
    bullets: [
      'L’utilisateur doit fournir des informations exactes et à jour.',
      'L’utilisateur est responsable de la confidentialité de son compte et de ses accès.',
      'L’utilisateur doit signaler sans délai toute utilisation non autorisée de son compte.',
    ],
  },
  {
    title: 'Utilisation autorisée',
    paragraphs: [
      'La plateforme doit être utilisée dans le respect de sa finalité : prospection, automatisation, génération de contenus et gestion de documents professionnels.',
      'L’utilisateur s’engage à ne pas détourner le service, à ne pas perturber son fonctionnement et à ne pas tenter d’accéder à des données qui ne lui sont pas destinées.',
    ],
  },
  {
    title: 'Contenus et responsabilités',
    paragraphs: [
      'Les contenus générés par la plateforme sont fournis à titre d’aide et doivent être relus et validés par l’utilisateur avant toute diffusion ou usage contractuel.',
      'L’utilisateur reste seul responsable de l’usage qu’il fait des documents, messages et actions produits via le service.',
    ],
    bullets: [
      'Vérifier l’exactitude des informations générées.',
      'Adapter les contenus au contexte juridique et commercial réel.',
      'Respecter les droits des tiers et la réglementation en vigueur.',
    ],
  },
  {
    title: 'Disponibilité et évolution du service',
    paragraphs: [
      'USTS peut faire évoluer, modifier, suspendre ou interrompre tout ou partie du service à tout moment, avec ou sans préavis selon les contraintes techniques.',
      'Des opérations de maintenance peuvent occasionner des interruptions temporaires.',
    ],
  },
  {
    title: 'Propriété intellectuelle',
    paragraphs: [
      'Les éléments de la plateforme, les marques, les logos, les interfaces et les contenus associés sont protégés par le droit de la propriété intellectuelle.',
      'Toute reproduction, représentation, adaptation ou extraction non autorisée est interdite.',
    ],
  },
]

export default function Cgu() {
  return (
    <LegalDocumentPage
      title="Conditions Générales d’Utilisation"
      subtitle="Règles d’accès et d’utilisation de la plateforme USTS"
      lastUpdated="02 avril 2026"
      intro="Cette page décrit les règles générales d’utilisation du service. Elle est pensée pour être publiée publiquement et référencée par Google OAuth."
      sections={sections}
      contactEmail="contact@usts.ai"
      contactLabel="Questions sur les CGU"
      contactDescription="Si vous avez une question sur ces conditions d’utilisation, contactez-nous à l’adresse ci-dessous."
    />
  )
}
